module.exports = __webpack_public_path__ + "static/media/icon.f09324db.png";